/**
 * The Insights articles.
 *
 * One file per article in this folder. Each exports `meta` - slug, title, date,
 * category, excerpt, reading time - and a default component holding the text as
 * markup. Publishing is a one-file job: drop it in and the index page, the
 * home-page teaser, the neighbour navigation and the sitemap pick it up. Nothing
 * needs registering here.
 *
 * `import.meta.glob` is Vite's build-time directory read, so the articles are
 * part of the bundle: no runtime fetch, no CMS. Excluding this file from the
 * pattern matters - without it the registry would glob itself.
 */

const modules = import.meta.glob(['./*.jsx', '!./index.jsx'], { eager: true })

export const posts = Object.values(modules)
  .map((module) => ({ ...module.meta, Body: module.default }))
  // Newest first; ties fall back to the title so the order is deterministic.
  .sort((a, b) => b.date.localeCompare(a.date) || a.title.localeCompare(b.title))

export function getPost(slug) {
  return posts.find((post) => post.slug === slug)
}

/** Previous / next in display order, for the article footer. */
export function getPostNeighbours(slug) {
  const index = posts.findIndex((post) => post.slug === slug)
  if (index === -1) return { previous: null, next: null }
  return {
    previous: index > 0 ? posts[index - 1] : null,
    next: index < posts.length - 1 ? posts[index + 1] : null,
  }
}

export const categories = [...new Set(posts.map((post) => post.category))].sort()
